/* Neubau D · eigene Google-Bewertungen (snippets/d-bew-eigen.liquid). Kein Netzwerk: alles steht schon im HTML.
   - Datum relativ („vor 3 Tagen“) wie bei Google, in der Shop-Sprache; das echte Datum bleibt im Tooltip und ohne JS sichtbar.
   - „… mehr“ nur bei abgeschnittenem Text, öffnet die ganze Bewertung im Dialog.
   - Laufbänder doppeln ihre Karten für die Endlosschleife (Kopien sind inert), Tempo in px/s wie Reputon.
     „Bewegung reduzieren“ = kein Laufband, Reihen zum Wischen, kein Pause-Knopf.
   - Raster: erst 3 (Handy) bzw. 8 Karten, „Mehr laden“ zeigt die nächsten. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DAY = 864e5;
  var fmt = null;
  try { fmt = new Intl.RelativeTimeFormat(document.documentElement.lang || 'de', { numeric: 'auto' }); } catch (e) { fmt = null; }

  function rel(iso) {
    var d = Math.floor((Date.now() - new Date(iso + 'T12:00:00').getTime()) / DAY);
    if (!fmt || isNaN(d) || d < 0) return null;
    if (d < 7) return fmt.format(-d, 'day');
    if (d < 30) return fmt.format(-Math.floor(d / 7), 'week');
    if (d < 365) return fmt.format(-Math.floor(d / 30), 'month');
    return fmt.format(-Math.floor(d / 365), 'year');
  }
  function dates(root) {
    root.querySelectorAll('.kbe-who time[datetime]').forEach(function (t) { var r = rel(t.dateTime); if (r) t.textContent = r; });
  }

  function moreButtons(root) {
    root.querySelectorAll('.kbe-card').forEach(function (c) {
      var t = c.querySelector('.kbe-text'), b = c.querySelector('[data-kbe-more]');
      if (t && b) b.hidden = !(t.scrollHeight > t.clientHeight + 1);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-kbe]').forEach(function (kbe) {
      if (kbe.dataset.kbeReady) return;
      kbe.dataset.kbeReady = '1';
      var dlg = kbe.querySelector('.kbe-dlg');
      dates(kbe);

      // Dialog
      kbe.addEventListener('click', function (e) {
        var b = e.target.closest('[data-kbe-more]'); if (!b || !dlg || dlg.contains(b)) return;
        var card = b.closest('.kbe-card').cloneNode(true);
        card.removeAttribute('inert'); card.removeAttribute('aria-hidden');
        dlg.querySelector('[data-kbe-body]').replaceChildren(card);
        dlg.showModal();
      });
      if (dlg) {
        dlg.querySelector('[data-kbe-close]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }

      // Laufbänder
      var bands = kbe.querySelectorAll('.kbe-band');
      if (bands.length && !reduce) {
        bands.forEach(function (band) {
          var track = band.querySelector('.kbe-track');
          Array.prototype.slice.call(track.children).forEach(function (c) {
            var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('inert', ''); track.appendChild(k);
          });
          var speed = Number(band.dataset.speed) || 45;
          track.style.setProperty('--kbe-dur', Math.round(track.scrollWidth / 2 / speed) + 's');
        });
        kbe.classList.add('is-run');
        var p = kbe.querySelector('[data-kbe-pause]');
        if (p) {
          p.hidden = false;
          p.addEventListener('click', function () {
            var on = kbe.classList.toggle('is-paused');
            p.setAttribute('aria-pressed', on ? 'true' : 'false');
            p.setAttribute('aria-label', on ? p.dataset.labelPlay : p.dataset.labelPause);
          });
        }
      }

      // Raster mit „Mehr laden“
      var grid = kbe.querySelector('[data-kbe-grid]'), load = kbe.querySelector('[data-kbe-load]');
      if (grid && load) {
        var step = matchMedia('(min-width: 900px)').matches ? 8 : 3, shown = step;
        var all = Array.prototype.slice.call(grid.children);
        var apply = function () {
          all.forEach(function (c, i) { c.hidden = i >= shown; });
          load.hidden = shown >= all.length;
          moreButtons(grid);
        };
        load.addEventListener('click', function () { shown += step; apply(); });
        apply();
      }

      requestAnimationFrame(function () { moreButtons(kbe); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moreButtons(kbe); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
